export default "__VITE_ASSET__Dj75_E$J__"